import { useLocale } from 'next-intl';
import { useParams } from 'next/navigation';

import { type Locale } from '@/i18n/routing';

import { useInfiniteLoader } from '@/hooks/useInfiniteLoader';
import { useSearchParamsResult } from '@/hooks/useSearchParamsResult';

import { MovieApi } from '@/api/domains/movie.api';
import { QueryFilterParams } from '@/api/types/filters.types';
import type { MovieList } from '@/api/types/movie.types';

import { MovieQueryKeys } from '@/contexts/QueryContext/query.keys';

export const useMovies = () => {
  const { moduleId } = useParams() as { moduleId: string };
  const { queryParams } = useSearchParamsResult();

  const locale = useLocale() as Locale;

  const result = useInfiniteLoader<MovieList, unknown>({
    queryKey: MovieQueryKeys.movies(moduleId, queryParams as QueryFilterParams, locale),
    queryFn: ({ pageParam = 1 }) =>
      MovieApi.fetchMovieList({
        page: pageParam,
        module_id: moduleId,
        items: 30,
        ...(queryParams as QueryFilterParams),
      }),
    initialPageParam: 1,
  });

  return result;
};
